import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  scrollArea: { height: '50%', overflowY: 'auto' },
  root: {
    minHeight: 430,
    width: 571,
    [theme.breakpoints.down('md')]: {
      minHeight: 300,
      width: 350,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        minHeight: 300,
        width: 350,
      }),
    },
    [theme.breakpoints.down('sm')]: {
      width: '75vw',
    },
  },
  description: {
    wordBreak: 'break-word',
  },
  dialogButton: {
    paddingInline: theme.spacing(4),
  },
  cancelButton: {
    '&, &:hover': {
      border: 'none',
      backgroundColor: 'transparent',
    },
  },
  yesButton: {
    width: 110,
    [theme.breakpoints.down('md')]: {
      height: 44,
      width: 144,
    },
  },
}));
